import { Component, OnInit, ElementRef } from '@angular/core';
import { collapseAnimation } from 'angular-animations';
import { OnboardingData } from '../../onboarding-screens-data.service';

@Component({
    selector: 'organisation-footer',
    templateUrl: './footer-organisation-details.component.html',
    styleUrls: ['../footer.scss'],
    animations: [collapseAnimation()]
})
export class OrganisationFooter implements OnInit {
    titles: boolean = false;
    tabs = [
        { id: 1, tab: 'PERSONAL_SETUP_COMPLETE' },
        { id: 2, tab: 'ORGANISATION_DETAILS' },
        { id: 3, tab: 'ORGANISATION_CERTIFICATION' },
        { id: 4, tab: 'ORGANISATION_SETUP_COMPLETE' }
    ];
    tabId: number;
    isMobile: boolean = false;
    constructor(private obsds: OnboardingData, private el: ElementRef) {}

    ngOnInit() {
        this.obsds.currentScreenAndTab$.subscribe(({ tab }) => {
            const currentTab = this.tabs.find(t => t.tab === tab);
            if (currentTab) {
                this.tabId = currentTab.id;
            }
        });
        this.setMobile();
        window.addEventListener('resize', () => this.setMobile(), true);
    }

    setMobile() {
        if (window.innerWidth <= 767) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }
}
